import {
    ERROR,
} from './constants';

interface IFormatValueParams {
    date: string | null;
    time: string | null;
    isDefaultEndDay?: boolean;
}

export function formatValue({date, time, isDefaultEndDay}: IFormatValueParams): Date | null {
    if (!date) {
        return null;
    }
    if (!time) {
        return isDefaultEndDay ? new Date(`${date}T23:59:59`) : new Date(`${date}T00:00:00`);
    }

    return new Date(`${date}T${time}:00`);
}

export function formatError(error: ERROR | null): string {
    switch (error) {
        case ERROR.IS_FUTURE_REQUIRED: {
            return 'Must be in the future';
        }
        case null: {
            return '';
        }
    }
}
